import { render, staticRenderFns } from "./babybookset.vue?vue&type=template&id=f8deb64a&scoped=true&"
import script from "./babybookset.vue?vue&type=script&lang=js&"
export * from "./babybookset.vue?vue&type=script&lang=js&"
import style0 from "./babybookset.vue?vue&type=style&index=0&id=f8deb64a&prod&lang=scss&"
import style1 from "./babybookset.vue?vue&type=style&index=1&id=f8deb64a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8deb64a",
  null
  
)

export default component.exports